/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const syncSessionData: BridgeCommands.Command<
    Types.Common.Nativeauth.SessionData,
    Types.Common.Nativeauth.SessionData
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NativeAuth',
    method: 'syncSessionData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const initiateLogIn: BridgeCommands.Command<
    Types.Common.Nativeauth.initiateLogInParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NativeAuth',
    method: 'initiateLogIn',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const initiateLogOut: BridgeCommands.Command<
    Types.Common.Nativeauth.initiateLogOutParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NativeAuth',
    method: 'initiateLogOut',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const initiateLogInALS: BridgeCommands.Command<
    Types.Common.Nativeauth.initiateLogInALSParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'NativeAuth',
    method: 'initiateLogInALS',
    persistent: false
};

export const Nativeauth = {
syncSessionData,
initiateLogIn,
initiateLogOut,
initiateLogInALS
};
